export default __webpack_public_path__ + "static/media/honey.ca2f025c.png";